<template>
  <div class="isler">
    <AppMain>
      <div class="container">
        <div class="page-title-container">
          <div class="row">
            <div class="col-12 col-md-7">
              <h1 class="mb-0 pb-0 display-4" id="title">İşler</h1>
              <nav class="breadcrumb-container d-inline-block" aria-label="breadcrumb">
                <ul class="breadcrumb pt-0">
                  <li class="breadcrumb-item">
                    <router-link to="/">Anasayfa</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/">İşler</router-link>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-12 col-md-5 d-flex align-items-start justify-content-end">
              <button  v-if="yetki_kontrol('is_ekle')"  class="btn btn-outline-primary btn-icon btn-icon-start w-100 w-md-auto" @click="isler_ekle">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                  class="acorn-icons acorn-icons-plus undefined">
                  <path d="M10 17 10 3M3 10 17 10"></path>
                </svg>
                <span>İş Ekle</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-sm-12 col-md-5 col-lg-3 col-xxl-2 mb-1">
            <div class="d-inline-block float-md-start me-1 mb-1 search-input-container w-100 shadow bg-foreground">
              <input class="form-control" placeholder="Arama" v-model="isler.arananKelime" />
              <span class="search-magnifier-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                  class="acorn-icons acorn-icons-search undefined">
                  <circle cx="9" cy="9" r="7"></circle>
                  <path d="M14 14L17.5 17.5"></path>
                </svg>
              </span>
              <span class="search-delete-icon d-none">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                  class="acorn-icons acorn-icons-close undefined">
                  <path d="M5 5 15 15M15 5 5 15"></path>
                </svg>
              </span>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 col-lg-9 col-xxl-10 text-end mb-1">
            <div class="d-inline-block">
              <div class="d-inline-block">
                <button class="btn p-0" data-bs-toggle="dropdown" type="button" data-bs-offset="0,3">
                  <span class="btn btn-icon btn-icon-only btn-foreground-alternate shadow dropdown" data-bs-delay="0"
                    data-bs-placement="top" data-bs-toggle="tooltip" title="" data-bs-original-title="Export">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                      class="acorn-icons acorn-icons-download undefined">
                      <path
                        d="M2 14V14.5C2 15.9045 2 16.6067 2.33706 17.1111C2.48298 17.3295 2.67048 17.517 2.88886 17.6629C3.39331 18 4.09554 18 5.5 18H14.5C15.9045 18 16.6067 18 17.1111 17.6629C17.3295 17.517 17.517 17.3295 17.6629 17.1111C18 16.6067 18 15.9045 18 14.5V14">
                      </path>
                      <path d="M14 10 10.7071 13.2929C10.3166 13.6834 9.68342 13.6834 9.29289 13.2929L6 10M10 2 10 13">
                      </path>
                    </svg>
                  </span>
                </button>
                <div class="dropdown-menu shadow dropdown-menu-end">
                  <button class="dropdown-item export-copy" type="button">
                    Kopyala
                  </button>
                  <button class="dropdown-item export-excel" type="button">
                    Excel İndir
                  </button>
                  <button class="dropdown-item export-cvs" type="button">
                    Cvs İndir
                  </button>
                </div>
              </div>
              <div class="dropdown-as-select d-inline-block ms-1" data-childselector="span">
                <button class="btn p-0 shadow" type="button" data-bs-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false" data-bs-offset="0,3">
                  <span class="btn btn-foreground-alternate dropdown-toggle" data-bs-toggle="tooltip"
                    data-bs-placement="top" data-bs-delay="0" title="" data-bs-original-title="Item Count">{{ isler.sayfadaKayit}}
                    Adet</span>
                </button>
                <div class="dropdown-menu shadow dropdown-menu-end" style="">
                  <a class="dropdown-item" @click="islerSayfadaKayitDegistir(5)">5 Adet</a>
                  <a class="dropdown-item" @click="islerSayfadaKayitDegistir(10)">10 Adet</a>
                  <a class="dropdown-item" @click="islerSayfadaKayitDegistir(20)">20 Adet</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2 class="small-title">Filtreler</h2>
        <div class="row mb-2">
        
            <div class="col-2">
                <label class="form-check custom-card w-100 position-relative p-0 m-0">
                  <input type="radio"   v-model="isler.filtreCard"  value="tumisler" 
                  :checked="isler.filtreCard === 'tumisler'"
                  class="form-check-input position-absolute e-2 t-2 z-index-1">
                  <span class="card form-check-label w-100">
                    <span class="card-body text-center p-0 pb-3">
                      <span class="mt-3 text-body text-primary d-block">Tüm İşler</span>
                      <span class="text-extra-small fw-medium text-muted d-block">{{filtreSayilar.tum_isler_adet}} Adet İş</span>
                    </span>
                  </span>
                </label>
              </div>

              <div class="col-2">
                <label class="form-check custom-card w-100 position-relative p-0 m-0">
                  <input type="radio"   v-model="isler.filtreCard" value="buhafta"  
                  :checked="isler.filtreCard === 'buhafta'"
                  class="form-check-input position-absolute e-2 t-2 z-index-1">
                  <span class="card form-check-label w-100">
                    <span class="card-body text-center p-0 pb-3">
                      <span class="mt-3 text-body text-primary d-block">Bu Haftaki İşler</span>
                      <span class="text-extra-small fw-medium text-muted d-block">{{filtreSayilar.bu_hafta_isler_adet}} Adet İş</span>
                    </span>
                  </span>
                </label>
              </div>

            
              <div class="col-2">
                <label class="form-check custom-card w-100 position-relative p-0 m-0">
                  <input type="radio" v-model="isler.filtreCard" value="devamisler"
                  :checked="isler.filtreCard === 'devamisler'"
                  class="form-check-input position-absolute e-2 t-2 z-index-1">
                  <span class="card form-check-label w-100">
                    <span class="card-body text-center p-0 pb-3">
                      <span class=" mt-3 text-body text-primary d-block">Yeni İşler</span>
                      <span class="text-extra-small fw-medium text-muted d-block">{{filtreSayilar.devam_adet}} Adet İş</span>
                    </span>
                  </span>
                </label>
              </div>
              <div class="col-2">
                <label class="form-check custom-card w-100 position-relative p-0 m-0">
                  <input type="radio" v-model="isler.filtreCard" value="hazirlaniyor" 
                  :checked="isler.filtreCard === 'hazirlaniyor'"
                  class="form-check-input position-absolute e-2 t-2 z-index-1">
                  <span class="card form-check-label w-100">
                    <span class="card-body text-center p-0 pb-3">
                      <span class=" mt-3 text-body text-primary d-block">Hazırlanan İşler</span>
                      <span class="text-extra-small fw-medium text-muted d-block">{{filtreSayilar.hazirlaniyor_isler_adet}} Adet İş</span>
                    </span>
                  </span>
                </label>
              </div>
              <div class="col-2">
                <label class="form-check custom-card w-100 position-relative p-0 m-0">
                  <input type="radio" v-model="isler.filtreCard" value="revizeli" 
                  :checked="isler.filtreCard === 'revizeli'"
                  class="form-check-input position-absolute e-2 t-2 z-index-1">
                  <span class="card form-check-label w-100">
                    <span class="card-body text-center p-0 pb-3">
                      <span class=" mt-3 text-body text-primary d-block">Revizeli İşler</span>
                      <span class="text-extra-small fw-medium text-muted d-block">{{filtreSayilar.revizeli_is_adet}} Adet İş</span>
                    </span>
                  </span>
                </label>
              </div>
              <div class="col-2">
                <label class="form-check custom-card w-100 position-relative p-0 m-0">
                  <input type="radio" v-model="isler.filtreCard" value="ajansonaybekliyor" 
                  :checked="isler.filtreCard === 'ajansonaybekliyor'"
                  class="form-check-input position-absolute e-2 t-2 z-index-1">
                  <span class="card form-check-label w-100">
                    <span class="card-body text-center p-0 pb-3">
                      <span class=" mt-3 text-body text-primary d-block">Onay Bekleyen İşler</span>
                      <span class="text-extra-small fw-medium text-muted d-block">{{filtreSayilar.onay_bekleyen_adet}} Adet İş</span>
                    </span>
                  </span>
                </label>
              </div>
           
        </div>
        <div class="row">

          <div :class="(seciliIs || isler.modal) ? 'col-md-8' : 'col-12'">
            <isCard :isler="isler" :duzenle="isler_duzenle" :formKaydetSonrasi="islerYenile" @update:isler="islerGuncelle" @seciliIs="isSecildi" :seciliIs="seciliIs" />
          </div>
          
          <div class="col-md-4" v-if="seciliIs">
            <div class="card h-100 shadow-sm border-0">
              <div class="card-body position-relative p-4">
                <button class="btn-close position-absolute top-0 end-0 m-3" @click="seciliIs = null" aria-label="Kapat"></button>
                <div class="mb-3 pb-2 border-bottom">
                  <h4 class="fw-bold mb-1 d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2 text-primary"><circle cx="11" cy="11" r="10"/><path d="M11 7v4l3 3"/></svg>
                    {{ seciliIs.ad }}
                  </h4>
                  <div class="text-muted small mb-1">Müşteri</div>
                  <div class="bg-light rounded p-2 mb-2">{{ musteriBilgileri(seciliIs.musteri).unvan || 'Bilinmiyor' }}</div>
                  <div class="text-muted small mb-2">İş Açıklaması</div>
                  <div class="bg-light rounded p-2 mb-2">{{ seciliIs.aciklama }}</div>
                  <div class="mt-2">
                    <span class="text-muted small">Durum</span>
                    <div class="row g-2 mt-1">
                      <div class="col-6" v-for="durum in durumlar" :key="durum.id">
                        <label class="form-check custom-card w-100 position-relative p-0 m-0">
                          <input type="radio" class="form-check-input position-absolute e-2 t-2 z-index-1" :value="durum.id" :checked="seciliIs.durum === durum.id" @change="onDurumChange(durum.id)" name="durumCardRadio">
                          <span class="card form-check-label w-100" :class="{'border-primary': seciliIs.durum === durum.id}">
                            <span class="card-body text-center p-2">
                              <span class="fw-bold d-block">{{ durum.ad }}</span>
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-3 pb-2 border-bottom">
                  <h6 class="fw-semibold mb-3 d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2 text-info"><rect x="3" y="3" width="15" height="12" rx="2"/></svg>
                    Yüklenen Çalışmalar
                  </h6>
                  <div class="row g-2" v-viewer>
                    <div class="col-12 col-sm-6" v-for="(file, index) in (seciliIs.calismalar || [])" :key="index">
                      <div class="card h-100 mb-2 border-0 shadow-sm">
                        <img v-if="isImage(file.dosya)"
                             :src="$globalVariable.uploadUrl + file.dosya"
                             @error="$globalVariable.varsayilanGorsel"
                             class="card-img-top sh-22 rounded-top"
                             style="cursor:pointer"
                             :data-original="$globalVariable.uploadUrl + file.dosya">
                        <div class="card-body pb-0">
                          <a v-if="isImage(file.dosya)"
                             href="javascript:void(0)"
                             class="h7 heading d-block text-truncate"
                             :data-original="$globalVariable.uploadUrl + file.dosya">
                             {{ file.ad }}
                          </a>
                          <span v-else class="h7 heading d-block text-truncate">{{ file.ad }}</span>
                        </div>
                        <div class="card-footer border-0 pt-0 bg-white">
                          <div class="d-flex align-items-center gap-2">
                            <a :href="$globalVariable.uploadUrl + file.dosya" target="_blank" class="btn btn-sm btn-outline-primary flex-fill">
                              İndir
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-2">
                  <h6 class="fw-semibold mb-3 d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2 text-secondary"><path d="M12 20h9"/><path d="M12 4h9"/><rect x="3" y="8" width="15" height="8" rx="2"/></svg>
                    Revizeler
                  </h6>
                  <revizeCard :revizeler="revizeler" :duzenle="revizeler_duzenle" :formKaydetSonrasi="revizelerYenile" @update:revizeler="revizelerGuncelle" />
                  <div class="mt-2">
                    <button class="btn btn-outline-primary btn-sm w-100" @click="revizeler_ekle">Revize Ekle</button>
                  </div>
                  <div class="modal fade modal-close-out show" style="display: block;" v-if="revizeler.modal">
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" v-if="revizeler.islem == 'ekle'"> Yeni Revize Ekle </h5>
                          <h5 class="modal-title" v-if="revizeler.islem == 'duzenle'">Revize Düzenleme </h5>
                          <button type="button" class="btn-close" @click="revizeler_iptal"></button>
                        </div>
                        <div class="modal-body">
                          <revizeForm :formIslem="revizeler.islem" :formData="revizeler.secili" :formKaydetSonrasi="revizelerYenile" :formIptal="revizeler_iptal" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <template v-if=" this.isler.modal && !seciliIs">
            <div class="col-md-4">
              <div class="card h-100">
                <div class="card-body">
                  <isForm 
                  :formIslem="isler.islem" 
                  :formData="isler.secili" 
                  :formKaydetSonrasi="islerYenile" 
                  :formIptal="isler_iptal" />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </AppMain>
  </div>
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";
import isCard from "@/components/isler/isCard.vue";
import isForm from "@/components/isler/isForm.vue";
import revizeCard from '@/components/revizeler/revizeCard.vue';
import revizeForm from '@/components/revizeler/revizeForm.vue';
import { getModulePageSize, setModulePageSize } from "@/services/paginationSettings";
// VueEasyLightbox kaldırıldı

export default {
  name: "islerView",
  components: {
    AppMain,
    isCard,
    isForm,
    revizeCard,
    revizeForm,
    // VueEasyLightbox kaldırıldı
  },
  data() {
    return {
      isler: {
        tumu:[],
        secili:null,
        seciliSayfa:1,
        sayfadaKayit:getModulePageSize("isler"),
        arananKelime:"",
        islem:'ekle',
        modal:false,

        filtreCard: 'tumisler',

        buHaftakiIslerIdler:[],
        revizeliIsIdler:[],
      },

        filtreSayilar: {},
        seciliIs: null,
        revizeler: {
          tumu: [],
          secili: null,
          seciliSayfa: 1,
          sayfadaKayit: 10,
          arananKelime: '',
          islem: 'ekle',
          modal: false,
        },
        musteriler: [],
        durumlar: [
          { id: 'musteriyeni', ad: 'Müşteri İsteği' },
          { id: 'ajansyeni', ad: 'Yeni' },
          { id: 'hazirlaniyor', ad: 'Hazırlanıyor' },
          { id: 'ajansonaybekliyor', ad: 'Ajans Onayı Bekliyor' },
          { id: 'musterionaybekliyor', ad: 'Müşteri Onayı Bekliyor' },
          { id: 'revizeli', ad: 'Revizeli' },
          { id: 'tamamlandi', ad: 'Tamamlandı' },
          { id: 'iptal', ad: 'İptal Edildi' },
        ],
        // lightboxVisible: false, // VueEasyLightbox kaldırıldı
        // lightboxIndex: 0, // VueEasyLightbox kaldırıldı
        // lightboxFiles: [], // VueEasyLightbox kaldırıldı
    };
  },
  watch: {
    seciliIs: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.revizelerGetir(newVal.id);
        } else {
          this.revizeler.tumu = [];
        }
      }
    }
  },
 
  mounted() {
    this.islerGetir();
    this.musterilerGetir();
  },
  methods: {
    yetki_kontrol(yetki){
      return yetkiKontrol(yetki);
    },
    musteriBilgileri(id) {
      return this.musteriler.find(mus => mus.id == id) || {};
    },
    kullaniciBilgileri(id) {
      if (this.seciliIs && Array.isArray(this.seciliIs.kullanicilarList)) {
        return this.seciliIs.kullanicilarList.find(kul => kul.id == id) || {};
      }
      return {};
    },
    islerGetir() {
      axiosCustom
        .get("isler")
        .then((response) => {
          this.isler.tumu = response.data.isler;

          this.filtreSayilar = response.data.filtresayilar;
          this.isler.buHaftakiIslerIdler = response.data.buhaftakiisler;
          this.isler.revizeliIsIdler = response.data.revizeli_is_idler;
        })
        .catch((error) => {
          console.error("Veri çekme hatası: ", error);
        });
    },
    islerYenile() {
      this.islerGetir();
      this.isler.modal=false;
    },
    islerGuncelle(veriler) {
      this.isler = veriler;
    },
   
    isler_ekle() {
     this.seciliIs = null; 
      this.isler.secili = {};
      this.isler.islem = "ekle";
      this.isler.modal=true;
    },
    isler_duzenle(is) {
       this.seciliIs = null; 
      this.isler.secili = is;
      this.isler.islem = "duzenle";
      this.isler.modal=true;
    },
    isler_iptal() {
      this.isler.secili = {};
      this.isler.modal=false;
    },
    
    islerSayfadaKayitDegistir(value) {
      this.isler.sayfadaKayit=value;
      setModulePageSize("isler", value);
    },

    isSecildi(is) {
      this.seciliIs = is;
    },
    isYukle(is) {
      // İş yükle modalı veya yönlendirmesi burada açılabilir
      this.isler_duzenle(is);
    },
    async musterilerGetir() {
      try {
        const res = await axiosCustom.get('musteriler');
        this.musteriler = res.data;
      } catch (e) {
        this.musteriler = [];
      }
    },
    async revizelerGetir(isId) {
      try {
        const response = await axiosCustom.get(`isler/detay/${isId}`);
        this.revizeler.tumu = response.data.revizeler || [];
        this.seciliIs.calismalar = response.data.calismalar || [];
      } catch (error) {
        this.revizeler.tumu = [];
        this.seciliIs.calismalar = [];
      }
    },
    revizelerGuncelle(veriler) {
      this.revizeler = veriler;
    },
    revizelerYenile() {
      if (this.seciliIs && this.seciliIs.id) {
        this.revizelerGetir(this.seciliIs.id);
      }
    },
    revizeler_duzenle(veri) {
      this.revizeler.secili = veri;
      this.revizeler.islem = 'duzenle';
      this.revizeler.modal = true;
    },
    revizeler_ekle() {
      this.revizeler.secili = { 'is': this.seciliIs.id };
      this.revizeler.islem = 'ekle';
      this.revizeler.modal = true;
    },
    revizeler_iptal() {
      this.revizeler.secili = {};
      this.revizeler.modal = false;
    },
    async isDurumKaydet() {
      if (!this.seciliIs) return;
      try {
        const formData = new FormData();
     
        formData.append('durum', this.seciliIs.durum);
        await axiosCustom.post(`isler/duzenle/${this.seciliIs.id}`, formData);
        this.$toast && this.$toast.success('İş durumu güncellendi');
        this.islerYenile();
      } catch (error) {
        this.$toast && this.$toast.error('Durum güncellenemedi');
      }
    },
    async onDurumChange(yeniDurum) {
      const eskiDurum = this.seciliIs.durum;
      if (yeniDurum === eskiDurum) return;
      const durumAd = (this.durumlar.find(d => d.id === yeniDurum) || {}).ad || yeniDurum;
      const result = await this.$swal({
        title: `${durumAd} durumuna geçilsin mi?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      });
      if (result.isConfirmed) {
        this.seciliIs.durum = yeniDurum;
        await this.isDurumKaydet();
      } else {
        // Geri al
        this.$nextTick(() => {
          this.seciliIs.durum = eskiDurum;
        });
      }
    },
    isImage(filename) {
      const ext = filename.split('.').pop().toLowerCase();
      return ["jpg","jpeg","png","gif","webp","bmp","svg"].includes(ext);
    },
  },
};
</script>
